<template>
  <div class="forgot-password inline-input">
    <h1 v-t.preserve="'auth.forgotPassword.title'" />
    <h2 v-t.preserve="'auth.forgotPassword.subtitle'" />

    <form class=" card card--rounded" @submit.prevent="submit" novalidate autocomplete="off">
      <pk-input v-model="email" :placeholder="$t('auth.forgotPassword.placeholder')" type="email" :error="$v.email.$error" inline />
      <btn flat :loading="loading" submit>{{ $t('auth.forgotPassword.send') }}</btn>
      <error-text :active="errorActive" :text="!errorActive ? '' : (errorCode ? $t('auth.forgotPassword.error.generic') : $t('auth.forgotPassword.error.email'))" />
      <transition name="success">
        <success-box v-if="success">
          <span v-html="$t('auth.forgotPassword.success', { email: lastEmailSent })" />
        </success-box>
      </transition>
    </form>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import peanutbutterAPI from '@/api/peanutbutter'
import formSubmit from '@/js/mixins/formSubmit'
import recaptchaService from '@/js/RecaptchaService'

export default {
  name: 'forgot-password',
  mixins: [formSubmit('requestReset')],
  data: () => ({
    success: false,
    email: '',
    lastEmailSent: ''
  }),
  validations: {
    email: { required, email }
  },
  computed: {
    errorActive() {
      return this.errorCode || this.$v.$error
    }
  },
  methods: {
    async requestReset() {
      if (this.success) {
        return
      }

      const email = this.email
      const recaptchaToken = await recaptchaService.getToken('reset_password')
      await peanutbutterAPI.requestPasswordReset(email, recaptchaToken)

      this.lastEmailSent = email
      this.success = true
    }
  },
  async created() {
    if (this.$route.params.email) {
      this.email = this.$route.params.email
    }
  }
}
</script>

<style lang="scss" scoped>
.forgot-password {
  .btn {
    width: 100% !important;
    margin-top: 3rem !important;
  }
  .input-container {
    & > .error-text {
      order: 2;
      margin-top: 8px;

      @media screen and (min-width: 568px) {
        order: 3;
      }
    }

    & > .success-box {
      order: 4;
    }
  }
}
</style>
